import React from 'react';

const people = [
  { id: 'you', x: 360, y: 200, label: 'You', you: true },
  { id: 'family', x: 170, y: 110, label: 'Family', delay: 1 },
  { id: 'friend', x: 550, y: 95, label: 'Friend', delay: 2 },
  { id: 'partner', x: 140, y: 280, label: 'Partner', delay: 3 },
  { id: 'team', x: 580, y: 270, label: 'Team', delay: 4 },
  { id: 'mentor', x: 360, y: 70, label: 'Mentor', delay: 5 }
];

const links = [
  ['you', 'family', true],
  ['you', 'friend', true],
  ['you', 'partner'],
  ['you', 'team'],
  ['you', 'mentor', true],
  ['family', 'partner'],
  ['friend', 'team']
];

const faces = {
  you: ['#2C2C2A', '#F4F4F2'],
  family: ['#5C5C58', '#EFEFED'],
  friend: ['#444441', '#F4F4F2'],
  partner: ['#3D3D3A', '#E8E8E4'],
  team: ['#6A6A65', '#F7F7F5'],
  mentor: ['#2C2C2A', '#EFEFED']
};

const getPerson = (id) => people.find((person) => person.id === id);

const HeroTogether = () => {
  return (
    <div className="hero-together" aria-hidden="false">
      <div className="hero-together-canvas">
        <svg
          className="hero-together-svg"
          viewBox="0 0 720 400"
          role="img"
          aria-label="Animated map of people staying connected"
        >
          <circle className="hero-together-pulse" cx="360" cy="200" r="92" />
          <circle className="hero-together-pulse" cx="360" cy="200" r="128" style={{ animationDelay: '1.4s' }} />

          {links.map(([from, to, strong]) => {
            const start = getPerson(from);
            const end = getPerson(to);
            return (
              <line
                key={`${from}-${to}`}
                className={`hero-together-link${strong ? ' is-strong' : ''}`}
                x1={start.x}
                y1={start.y}
                x2={end.x}
                y2={end.y}
              />
            );
          })}

          {people.map((person) => {
            const [hair, skin] = faces[person.id];
            const nodeClass = [
              'hero-node',
              person.you ? 'hero-node-you' : '',
              person.delay ? `hero-node-delay-${person.delay}` : ''
            ].filter(Boolean).join(' ');

            return (
              <g key={person.id} transform={`translate(${person.x} ${person.y})`}>
                <g className={nodeClass}>
                  <circle className="hero-node-ring" r={person.you ? 34 : 28} />
                  <circle r={person.you ? 26 : 21} fill={skin} />
                  <circle cy="-4" r={person.you ? 9 : 7.5} fill={hair} />
                  <path
                    d={person.you
                      ? 'M-16 18c2-10 30-10 32 0v4H-16z'
                      : 'M-13 15c2-8 24-8 26 0v3H-13z'}
                    fill={hair}
                  />
                  <text className="hero-node-label" y={person.you ? 52 : 46} textAnchor="middle">
                    {person.label}
                  </text>
                </g>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
};

export default HeroTogether;
